import { TransactionsTable } from '@/components/organisms';
import { TeamLeaguesErrorPage } from '@/components/organisms/TeamLeaguesErrorPage';
import { getPlayerTransactionsController } from '@/interface-adapters/controllers/player/get-player-transactions.controller';

interface TransactionsTableProps {
	organizationId: string;
	playerId: string;
}

export const TransactionsTableSSR = async ({ organizationId, playerId }: TransactionsTableProps) => {
	const playerTransactions = await getPlayerTransactionsController(organizationId, playerId);

	if (!playerTransactions.data) {
		return (
			<TeamLeaguesErrorPage
				title="Unforced error!"
				description=" We just hit out of bounds...Please try back later."
				shouldTakeScreenWidth={false}
			/>
		);
	}

	return <TransactionsTable playerTransactions={playerTransactions.data} />;
};
